import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { Base } from '@itsrever/design-system'

// The filter bars' copy for Base.ChecklistPopover; without `search` there is no search box.
export const useChecklistLabels = (search?: string) => {
  const { t } = useTranslation()
  return {
    clearAll: t('filter.clear_all'),
    cancel: t('filter.cancel'),
    apply: t('filter.apply'),
    selectAll: t('filter.select_all'),
    noOptions: t('filter.no_options_title'),
    search
  }
}

export const renderChecklistCount = (count: number) => (
  <Base.Badge variant="count">{count}</Base.Badge>
)

type FilterSelectProps = {
  param: string
  label: string
  options: Base.ChecklistOption[]
  onChange: (values: string[]) => void
}

// A filter bar's multi-select, whose selection lives in the URL under param.
export const FilterSelect = ({
  param,
  label,
  options,
  onChange
}: FilterSelectProps) => {
  const { t } = useTranslation()
  const labels = useChecklistLabels(
    `${t('filter.search')} ${label.toLowerCase()}`
  )
  const [searchParams] = useSearchParams()
  const selected = searchParams.getAll(param)

  return (
    <Base.ChecklistPopover
      trigger={label}
      count={selected.length}
      renderCount={renderChecklistCount}
      title={`${t('filter.select')} ${label.toLowerCase()}`}
      options={options}
      selected={selected}
      onApply={onChange}
      labels={labels}
    />
  )
}
